import ClientNavbar from "../../Client/ClientLayout/ClientNavbar.js";
import ClientFooter from "../../Client/ClientLayout/ClientFooter.js";
import Form from "react-bootstrap/Form";
import {
  Button,
  Card,
  CardBody,
  FormGroup,
  Input,
  InputGroupText,
  InputGroup,
  CardHeader,
} from "react-bootstrap";
import React, { useEffect, useState } from "react";
import { API_URL } from "../../../Constant.js";
import fetchWithAuth from "../../../fetchWithAuth.js";
import { ToastContainer, toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { FaEye, FaEyeSlash } from "react-icons/fa";

const ClientCreateAccount = () => {
  const navigate = useNavigate();

  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [mobileNo, setMobileNo] = useState("");
  const [emailId, setEmailId] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [termsAndConditons, setTermsAndConditons] = useState(false);
  const [countries, setCountries] = useState([]);
  const [selectedCountryCode, setSelectedCountryCode] = useState(""); // Default empty
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const [firstNameError, setFirstNameError] = useState("");
  const [lastNameError, setLastNameError] = useState("");
  const [mobileNoError, setMobileNoError] = useState("");
  const [emailIdError, setEmailIdError] = useState("");
  const [passwordError, setPasswordError] = useState("");
  const [confirmPasswordError, setConfirmPasswordError] = useState("");
  const [termsAndConditonsError, setTermsAndConditonsError] = useState("");

  const [isBookingForOther, setIsBookingForOther] = useState(false);
  const [showSubmitCard, setShowSubmitCard] = useState(false);

  const handleNextClick = () => {
    setShowSubmitCard(true);
  };

  const chkConfirmPassword = (confirmPassword) => {
    if (password != confirmPassword) {
      setConfirmPasswordError("Password Does not Match !");
    } else {
      setConfirmPasswordError("");
    }
  };

  const validateForm = () => {
    let isValid = true;

    if (!firstName) {
      setFirstNameError("* Please enter First Name");
      isValid = false;
    } else {
      setFirstNameError("");
    }

    if (!lastName) {
      setLastNameError("* Please enter Last Name");
      isValid = false;
    } else {
      setLastNameError("");
    }

    if (!mobileNo) {
      setMobileNoError("* Please enter Mobile No.");
      isValid = false;
    } else if (!/^\d{8,12}$/.test(mobileNo)) {
      setMobileNoError("* Mobile No must be between 8-12 digits");
      isValid = false;
    } else {
      setMobileNoError("");
    }

    if (!emailId) {
      setEmailIdError("* Please enter Email Id");
      isValid = false;
    } else if (
      !/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(emailId)
    ) {
      setEmailIdError("* Please enter a valid EmailId");
      isValid = false;
    } else {
      setEmailIdError("");
    }

    if (!password) {
      setPasswordError("* Please enter Password");
      isValid = false;
    } else if (
      !/^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{6,}$/.test(
        password
      )
    ) {
      setPasswordError(
        "* Password must be at least 6 characters long, contain letters, numbers, and 1 symbol"
      );
      isValid = false;
    } else {
      setPasswordError("");
    }

    if (!confirmPassword) {
      setConfirmPasswordError("* Please Confirm Password");
      isValid = false;
    } else {
      setConfirmPasswordError("");
    }

    if (!termsAndConditons) {
      setTermsAndConditonsError("* Please Accept Terms & Conditions");
      isValid = false;
    } else {
      setTermsAndConditonsError("");
    }

    return isValid;
  };

  const handleSave = async (event) => {
    event.preventDefault();
    if (!validateForm()) return;
  
    const CurrentDate = new Date().toISOString();
    const fullMobileNo = selectedCountryCode + mobileNo; // Concatenating country code with mobile number
  
    const data = {
      loginId: 0,
      userTypeId: 3,
      firstName: firstName,
      lastName: lastName,
      mobileNo: fullMobileNo, // Sending full mobile number
      emailId: emailId,
      password: password,
      isOther: isBookingForOther,
      termsAndCondition: termsAndConditons,
      createdOn: CurrentDate,
      isActive: true,
      isDelete: false,
    };
  
    try {
      const response = await fetch(API_URL + "api/Login/SaveRegistrationDetails", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      });
  
      if (response.ok) {
        const result = await response.json();
        toast.success("Patient details saved successfully"); // Updated toast message
  
        console.log("Patient details saved successfully:", result);
  
        localStorage.setItem("token", result.token);
        localStorage.setItem("loginId", result.data.loginId);
        localStorage.setItem("userTypeId", result.data.userTypeId);
        localStorage.setItem("firstName", result.data.firstName);
        localStorage.setItem("lastName", result.data.lastName);
        localStorage.setItem("mobileno", result.data.mobileNo);
        localStorage.setItem("emailId", result.data.emailId);
        localStorage.setItem("isDeleted", result.data.isDeleted);
  
        setFirstName("");
        setLastName("");
        setMobileNo("");
        setEmailId("");
        setPassword("");
        setConfirmPassword("");
        setTermsAndConditons(false);
  
        GoNext(result.data.loginId);
      } else {
        toast.error("Failed to save patient details. Please try again.");
        const errorText = await response.text();
        console.error("Error during save:", errorText);
      }
    } catch (error) {
      console.error("Error during save:", error);
      toast.error("An error occurred while saving patient details.");
    }
  };

  const GoNext = async (loginId) => {
    try {
      const response = await fetch(
        `${API_URL}api/Login/GetClientNextStepPage/${loginId}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (!response.ok) {
        throw new Error("Failed to fetch course list");
      }

      const data = await response.json();
      alert("Data is : " + JSON.stringify(data));
      navigate(data.result);
    } catch (err) {
    } finally {
    }
  };

  const handleCancel = () => {
    setFirstName("");
    setLastName("");
    setMobileNo("");
    setEmailId("");
    setPassword("");
    setConfirmPassword("");
    setSelectedCountryCode(""); // Reset country code if needed
    setIsBookingForOther(false); // Reset booking selection
    setTermsAndConditons(false);
    setFirstNameError("");
    setLastNameError("");
    setMobileNoError("");
    setEmailIdError("");
    setPasswordError("");
    setConfirmPasswordError("");
    setTermsAndConditonsError("");
  };
  useEffect(() => {
    fetchCountries();
  }, []);

  const fetchCountries = async () => {
    try {
      const response = await fetch(API_URL + "Masters/GetCountryList");
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      const data = await response.json();
      console.log("Fetched Countries:", data);

      if (data && Array.isArray(data.data)) {
        setCountries(data.data);

        // Set default country code (first item in API response)
        if (data.data.length > 0) {
          setSelectedCountryCode(data.data[0].countryCode);
        }
      } else {
        console.error("Invalid API response format:", data);
        setCountries([]);
      }
    } catch (error) {
      console.error("Error fetching countries:", error);
      setCountries([]);
    }
  };
  return (
    <>
      <ToastContainer />
      <div>
        <ClientNavbar />
        <br />
        {!showSubmitCard ? (
          <Card
            style={{
              width: "700px",
              height: "400px",
              boxShadow: "0px 4px 12px rgba(0,0,0,0.1)",
              border: "1px solid gray",
              borderRadius: "10px",
              marginLeft: "26%",
              padding: "20px",
              marginTop: "20px",
            }}
          >
            <Card.Body>
              <Card.Text>
                <center>
                  <Card.Title>Who Are You Booking For</Card.Title>
                </center>
                <hr />
                <Form>
                  <br />
                  <br />
                  <br />
                  <center>
                    <Form.Group className="mb-3" controlId="formBasicCheckbox">
                      <Button
                        variant="outline-info"
                        size="lg"
                        onClick={(e) => {
                          e.target.classList.toggle("btn-highlight");
                          setIsBookingForOther(false);
                        }}
                        style={{ fontSize: "1.1rem" }}
                      >
                        Booking For Yourself
                      </Button>
                      &nbsp;&nbsp;&nbsp;
                      <Button
                        variant="outline-info"
                        size="lg"
                        onClick={(e) => {
                          e.target.classList.toggle("btn-highlight");
                          setIsBookingForOther(true);
                        }}
                        style={{ fontSize: "1.1rem" }}
                      >
                        Booking For Other Person
                      </Button>
                    </Form.Group>
                  </center>
                  <br />
                  <center>
                    <Button
                      variant="primary"
                      size="lg"
                      onClick={handleNextClick}
                      style={{ fontSize: "1.1rem" }}
                    >
                      Next
                    </Button>
                  </center>
                </Form>
              </Card.Text>
            </Card.Body>
          </Card>
        ) : (
          <Card
            style={{
              width: "700px",
              boxShadow: "0px 4px 12px rgba(0,0,0,0.1)",
              border: "1px solid gray",
              borderRadius: "10px",
              marginLeft: "26%",
              padding: "20px",
            }}
          >
            <Card.Body>
              <Card.Text>
                <center>
                  <Card.Title>Create Account</Card.Title>
                </center>
                <hr />
                <Form>
                  <Form.Group className="mb-3" controlId="formFirstName">
                    <Form.Label>
                      First Name <b style={{ color: "red" }}>*</b>
                    </Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="First Name"
                      onChange={(e) => {
                        const value = e.target.value;
                        setFirstName(value);
                        if (value) setFirstNameError("");
                      }}
                    />
                    {firstNameError && (
                      <div style={{ color: "red", fontSize: "0.9em" }}>
                        {firstNameError}
                      </div>
                    )}
                  </Form.Group>

                  <Form.Group className="mb-3" controlId="formLastName">
                    <Form.Label>
                      Last Name <b style={{ color: "red" }}>*</b>
                    </Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Last Name"
                      onChange={(e) => {
                        const value = e.target.value;
                        setLastName(value);
                        if (value) setLastNameError("");
                      }}
                    />
                    {lastNameError && (
                      <div style={{ color: "red", fontSize: "0.9em" }}>
                        {lastNameError}
                      </div>
                    )}
                  </Form.Group>

                  <Form.Group className="mb-3" controlId="formMobileNo">
                    <Form.Label>
                      Mobile No. <b style={{ color: "red" }}>*</b>
                    </Form.Label>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "8px",
                      }}
                    >
                      {/* Country Code Dropdown */}
                      <Form.Select
                        value={selectedCountryCode}
                        className="form-control"
                        onChange={(e) => setSelectedCountryCode(e.target.value)}
                        style={{ width: "100px" }}
                      >
                        {countries.map((country) => (
                          <option key={country.id} value={country.countryCode}>
                            {country.countryCode} ({country.countryName})
                          </option>
                        ))}
                      </Form.Select>

                      {/* Mobile No Input */}
                      <Form.Control
                        type="text"
                        placeholder="Mobile No."
                        value={mobileNo}
                        onChange={(e) => {
                          const value = e.target.value;
                          if (/^\d*$/.test(value)) {
                            setMobileNo(value);
                            setMobileNoError("");
                          }
                        }}
                      />
                    </div>

                    {mobileNoError && (
                      <div style={{ color: "red", fontSize: "0.9em" }}>
                        {mobileNoError}
                      </div>
                    )}
                  </Form.Group>

                  <Form.Group className="mb-3" controlId="formEmailId">
                    <Form.Label>
                      Email Id <b style={{ color: "red" }}>*</b>
                    </Form.Label>
                    <Form.Control
                      type="email"
                      placeholder="Email Id"
                      onChange={(e) => {
                        const value = e.target.value;
                        setEmailId(value);
                        if (value) setEmailIdError("");
                      }}
                    />
                    {emailIdError && (
                      <div style={{ color: "red", fontSize: "0.9em" }}>
                        {emailIdError}
                      </div>
                    )}
                  </Form.Group>

                  <Form.Group
                    className="mb-3 position-relative"
                    controlId="formPassword"
                  >
                    <Form.Label>
                      Password <b style={{ color: "red" }}>*</b>
                    </Form.Label>
                    <div style={{ position: "relative" }}>
                      <Form.Control
                        type={showPassword ? "text" : "password"}
                        placeholder="Password"
                        onChange={(e) => {
                          const value = e.target.value;
                          setPassword(value);
                          if (value) setPasswordError("");
                          // Revalidate confirm password on password change
                          chkConfirmPassword(confirmPassword);
                        }}
                      />
                      <span
                        onClick={() => setShowPassword(!showPassword)}
                        style={{
                          position: "absolute",
                          right: "10px",
                          top: "50%",
                          transform: "translateY(-50%)",
                          cursor: "pointer",
                        }}
                      >
                        {showPassword ? <FaEyeSlash /> : <FaEye />}
                      </span>
                    </div>
                    {passwordError && (
                      <div style={{ color: "red", fontSize: "0.9em" }}>
                        {passwordError}
                      </div>
                    )}
                  </Form.Group>

                  {/* Confirm Password Field */}
                  <Form.Group
                    className="mb-3 position-relative"
                    controlId="formConfirmPassword"
                  >
                    <Form.Label>
                      Confirm Password <b style={{ color: "red" }}>*</b>
                    </Form.Label>
                    <div style={{ position: "relative" }}>
                      <Form.Control
                        type={showConfirmPassword ? "text" : "password"}
                        placeholder="Confirm Password"
                        onChange={(e) => {
                          const value = e.target.value;
                          setConfirmPassword(value);
                          chkConfirmPassword(value);
                        }}
                      />
                      <span
                        onClick={() =>
                          setShowConfirmPassword(!showConfirmPassword)
                        }
                        style={{
                          position: "absolute",
                          right: "10px",
                          top: "50%",
                          transform: "translateY(-50%)",
                          cursor: "pointer",
                        }}
                      >
                        {showConfirmPassword ? <FaEyeSlash /> : <FaEye />}
                      </span>
                    </div>
                    {confirmPasswordError && (
                      <div style={{ color: "red", fontSize: "0.9em" }}>
                        {confirmPasswordError}
                      </div>
                    )}
                  </Form.Group>

                  <Form.Group
                    className="mb-3"
                    controlId="formTermsAndConditions"
                  >
                    <Form.Check
                      type="checkbox"
                      label={
                        <>
                          Accept Terms And Conditions{" "}
                          <b style={{ color: "red" }}>*</b>
                        </>
                      }
                      onChange={(e) => {
                        const value = e.target.checked;
                        setTermsAndConditons(value);
                        if (value == true) setTermsAndConditonsError("");
                      }}
                    />
                    {termsAndConditonsError && (
                      <div style={{ color: "red", fontSize: "0.9em" }}>
                        {termsAndConditonsError}
                      </div>
                    )}
                  </Form.Group>

                  <center>
                    <Button
                      variant="primary"
                      type="submit"
                      onClick={handleSave}
                    >
                      Submit
                    </Button>
                    &nbsp; &nbsp;
                    <Button
                      variant="secondary"
                      type="Cancel"
                      //onClick={handleSave}
                    >
                      Cancel
                    </Button>
                  </center>
                </Form>
              </Card.Text>
            </Card.Body>
          </Card>
        )}
        <br />
        <ClientFooter />
      </div>
    </>
  );
};

export default ClientCreateAccount;
